import t from './story09.translations'

export default {
  title: t.title,
  excerpt: t.excerpt,
  regionName: t.regionName,

  prose: [
    // Run 1 — what tantalum is for, what it costs Congo, and how the war economy works.
    [{ text: t.s1P1 }, { text: t.s1P2 }, { text: t.s1P3 }, { text: t.s1P4 }],
    // Run 2 — resumes after the Katanga figure: north versus south, exile, the campaign.
    [{ text: t.s2P1 }, { text: t.s2P2 }, { text: t.s2P3 }],
    // Run 3 — the close: refurbished tech, the network, the appeal — and the doc's
    // sign-off, which is body copy here because the layout has nowhere else to put it.
    [{ text: t.s3P1 }, { text: t.s3P2 }, { text: t.s3P3 }, { text: t.s3P4 }],
  ],

  captions: [
    // 01 — hero, the worker near a Katanga operation.
    [t.f1P1],
    // 02 — children working near a Katanga mine.
    [t.f2P1],
    // 03 — miners searching the soil.
    [t.f3P1],
  ],
} as const
